<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Extracto de movimientos</div>
        <span class="grey--text text--lighten-2">Relación de movimientos en el extracto de la propiedad actualizado hasta {{ extracto.FECHA | moment("DD/MM/YYYY") }}</span>

        <v-select 
          v-model="idPropiedadActiva"
          :items="propiedades"
          item-text="NOMBRE"
          item-value="IDPROPIEDAD"
          class="pt-3"
          solo flat hide-details full-width>
        </v-select>
      </div>
    </v-card-title>
  
    <v-data-table
      :headers="cabecera"
      :items="extracto.APUNTES"
      hide-actions
      class="elevation-1 pa-2"
      no-data-text="Sin datos"
    >
      <template slot="items" slot-scope="props">
        
        <td class="text-xs-left">{{ props.item.FECHA | moment("DD/MM/YYYY") }}</td>
        <td class="text-xs-left">{{ props.item.DESCRIPCION }}</td>
        <td class="text-xs-right">{{ props.item.DEBE | monedaSinCero }}</td>
        <td class="text-xs-right">{{ props.item.HABER | monedaSinCero}}</td>
        <td class="text-xs-right">{{ props.item.SALDO | moneda }}</td>
      </template>
    </v-data-table>
    
  </v-card>
</template>

<style>
</style>

<script>
  import { mapState } from 'vuex'
  import { PROPIEDADES_REQUEST, PROPIEDADES_ACTIVATE } from '../store/actions/propiedades'
  import { EXTRACTO_REQUEST } from '../store/actions/extracto';

  export default {
    name: 'VerExtracto',
    
    data: function () {
      return {
          cabecera: [
              {
                  text: 'Fecha',
                  align: 'left',
                  sortable: false,
                  value: 'FECHA'
              },
              {
                  text: 'Descripción',
                  align: 'left',
                  sortable: false,
                  value: 'DESCRIPCION'
              },
              {
                  text: 'Debe',
                  align: 'right',
                  sortable: false,
                  value: 'DEBE'
              },
              {
                  text: 'Haber',
                  align: 'right',
                  sortable: false,
                  value: 'HABER'
              },
              {
                  text: 'Saldo',
                  align: 'right',
                  sortable: false,
                  value: 'SALDO'
              }
          ]
      }
    },
    created: function () {
      this.$store.dispatch(PROPIEDADES_REQUEST, {
        idComunidad: this.$store.state.comunidades.idComunidadActiva
      })
      .then(() => {
        this.cargarExtracto()
      })  
    },
    methods: {
      cargarExtracto() {
        this.$store.dispatch(EXTRACTO_REQUEST, {
          idPropiedad: this.$store.state.propiedades.idPropiedadActiva,
          inicio: "01/01/2000",
          fin: "31/12/2100"
        })
      }
    },
    filters: {
        monedaSinCero: function (value) {
            if (!value) return ''
            value = value.toLocaleString('es-ES', { style: 'currency', currency: 'EUR'})
            return value
        },
        moneda: function (value) {
            value = value.toLocaleString('es-ES', { style: 'currency', currency: 'EUR'})
            return value
        }
    },
    computed: {
      idPropiedadActiva: {
        get() {
          return this.$store.getters.idPropiedadActiva
        },
        set(value) {
          this.$store.dispatch(PROPIEDADES_ACTIVATE, value)
          this.cargarExtracto()
        }
      },
      ...mapState({
        propiedades: state => state.propiedades.propiedades,
        extracto: state => state.extracto.extracto
      })
    }
  }
</script>